import contentApi from '../api/ContentApi';
import * as types from './actionTypes';

export function loadContentSuccess(templates: any[]) {
    return { type: types.LOAD_CONTENT_SUCCESS, templates };
}

export function loadContentFailure() {
    return { type: types.LOAD_CONTENT_FAILURE };
}

export function loadContent() {
    return async (dispatch) => {
        try {
            const content = await contentApi.getContent();
            dispatch(loadContentSuccess(content));
        } catch (error) {
            dispatch(loadContentFailure());
            throw error;
        }
    };
}
